import { Factory } from "fishery";
import { PaymentType } from "../components/PaymentBatchesTable/types";
import { PaymentMethod, PaymentStatus } from "../graphql/supergraphOperations";
import { moneyFactory } from "./money.factory";

export const paymentTypeFactory = Factory.define<PaymentType>(() => {
  return {
    objectId: "sampleId",
    status: PaymentStatus.Pending,
    method: PaymentMethod.Ach,
    amount: moneyFactory.build(),
  };
});
